import * as React from "react";
import { Apps28Regular, Apps28Filled } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";
import { basePath } from "./BIPartnerCenterRoutes";

const BIPartnerCenterApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "BIPartnerCenter" */ "./BIPartnerCenterApp");
    return { default: namedExport.BIPartnerCenterApp };
});

export const BIPartnerCenter: TeamAppConfig = {
    title: "Foundation Business Insights Partner Center",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "Portal to manage all data contracts owned by the Foundation Business Insights team with their partner teams.",
    team: "BusinessInsights",
    publicId: "FOUNDATIONBUSINESSINSIGHTS\\Triage",
    owner: "FoundationBIEng@microsoft.com",
    role: "*",
    tags: [],
    app: BIPartnerCenterApp,
    path: basePath
};
